import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  ClientDetailsScreenComponent
} from './screen/client-details-screen/client-details-screen.component';
import {SharedModule} from "../../shared/shared.module";
import {StoreModule} from "@ngrx/store";
import {EffectsModule} from "@ngrx/effects";
import {ClientDetailsEffects} from "./core/client-details.effects";
import {reducer} from "./core/client-details.reducer";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";


@NgModule({
  declarations: [
    ClientDetailsScreenComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('ss-cord.client-details', reducer),
    EffectsModule.forFeature(
      [ClientDetailsEffects]
    ),
    MatSlideToggleModule,
  ]
})
export class ClientDetailsModule {
}
